import React from 'react';

const linkify = (text) =>
  text.split(/(https?:\/\/[^\s]+?)(?=[.,;)]?(?:\s|$))/g).map((part, i) =>
    /^https?:\/\//.test(part) ? (
      <a key={i} href={part} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline break-words">
        {part.replace(/^https?:\/\//, '')}
      </a>
    ) : (
      part
    )
  );

const Block = ({ block }) => {
  switch (block.type) {
    case 'h2':
      return <h2 className="text-2xl font-bold text-[#1e2d3b] mt-10 mb-4">{block.text}</h2>;
    case 'h3':
      return <h3 className="text-lg font-semibold text-[#1e2d3b] mt-6 mb-2">{block.text}</h3>;
    case 'small':
      return <p className="text-xs font-semibold tracking-widest uppercase text-slate-500">{block.text}</p>;
    case 'quote':
      return (
        <blockquote className="border-l-4 border-blue-500 bg-slate-50 rounded-r-xl px-6 py-5 my-6">
          <p className="text-slate-700 italic leading-relaxed">&ldquo;{block.text}&rdquo;</p>
          {block.cite && <footer className="mt-3 text-sm font-semibold text-[#1e2d3b] not-italic">— {block.cite}</footer>}
        </blockquote>
      );
    case 'list':
      return (
        <ul className="list-disc pl-6 space-y-2 text-slate-700 leading-relaxed">
          {block.items.map((item) => <li key={item}>{item}</li>)}
        </ul>
      );
    case 'contact':
      return (
        <address className="not-italic text-slate-700 leading-relaxed">
          {block.lines.map((line) => <div key={line}>{linkify(line)}</div>)}
        </address>
      );
    default:
      return <p className="text-slate-700 leading-relaxed">{linkify(block.text)}</p>;
  }
};

export const NewsArticleBody = ({ body }) => (
  <div className="space-y-5" data-testid="news-article-body">
    {body.map((block, i) => <Block key={`${block.type}-${i}`} block={block} />)}
  </div>
);

export default NewsArticleBody;
